import { ChoiceList } from '../types/choice-list.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { choiceListElementDefinition } from './choice-list-element.definition';

export const choiceListDefinition: EntityDefinition<ChoiceList> = {
  entityType: 'ChoiceList',
  i18nBase: 'entities.choiceList',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.choiceList.fields.name',
        sortable: true,
        filterable: true,
        class: 'w-full min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [
    { field: 'name', labelKey: 'entities.choiceList.fields.name', required: true, type: 'text', minLength: 3, maxLength: 50 },
    {
      field: 'type',
      labelKey: 'common.labels.type',
      required: false,
      type: 'hidden',
      defaultValue: '',
    },
  ],
  childRelation: {
    type: 'ChoiceListElement',
    parentIdField: 'id',
    childParentIdField: 'choiceListId',
    displayName: 'Choix',
  },
  childDefinition: choiceListElementDefinition,
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: ChoiceList) => !entity.isUsed,
      errorMessageKey: 'entities.choiceList.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: ChoiceList, store) => {
        if (!store) return true;
        const entities = store.getData<ChoiceList>('ChoiceList')();
        return !entities.some(g => g.name?.toLowerCase()?.trim() === entity.name?.toLowerCase()?.trim());
      },
      errorMessageKey: 'entities.choiceList.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: ChoiceList, store) => {
        if (!store) return true;
        const entities = store.getData<ChoiceList>('ChoiceList')();
        return !entities.some(g => g.name?.toLowerCase()?.trim() === entity.name?.toLowerCase()?.trim() && g.id !== entity.id);
      },
      errorMessageKey: 'entities.choiceList.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.choiceList.messages.createTitle',
      edit: () => 'entities.choiceList.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.choiceList.messages.addButton',
      create: () => 'entities.choiceList.messages.addButton',
      edit: () => 'entities.choiceList.messages.editTitleWithName',
      delete: () => 'entities.choiceList.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.choiceList.messages.deleteConfirm',
  },
  enableFiltering: true,
};
